import { generateAPI } from "../api.generator";
import { NotificationsResponse } from "../../types/notification";

export const getNotifications = generateAPI<
  {
    query: {
      limit?: number;
      offset?: number;
    };
  },
  NotificationsResponse
>("get", "notifications");